export enum IntervalSize {
  Default = 1,
  Annually = 1,
  Monthly = 12,
  Biweekly = 26,
}

export enum IntervalPercent {
  After_Tax = "at",
  Before_Tax = "bt",
}
